import apiFetch from './apiFetch.js'

let cache

export default function isLaunched (feature) {
  if (!cache) cache = {}
  if (cache[feature] !== undefined) return cache[feature]
  return cache[feature] = apiFetch('GET', 'Launch', {feature})
    .catch(() => {
      // console && console.error(`Failed Feature API request for "${feature}"`)
      // console && console.error(err)
      return false
    })
}
